import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
// import './css/base/colors.css';
import './css/base/typography.css';
import './css/components/common.css';
import './css/components/buttons.css';
import './css/components/forms.css';
import './css/components/modals.css';
import './css/layout/grid.css';
import './css/layout/spacing.css';
import './css/utilities/helpers.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);